import React, { useEffect, useState, useCallback } from 'react';
import { apiService, apiHelpers } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const resp = await apiService.getUsers();
      setUsers(resp.data || []);
    } catch (err) {
      setError(apiHelpers.formatError(err));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const adminCount = users.filter((u) => u.is_superuser && u.is_active).length;

  const toggle = async (user) => {
    try {
      setError(null);
      if (user.is_superuser) {
        await apiService.demoteUser(user.id);
      } else {
        await apiService.promoteUser(user.id);
      }
      await load();
    } catch (err) {
      setError(apiHelpers.formatError(err));
    }
  };

  if (loading && users.length === 0) {
    return <LoadingSpinner text="Loading users..." />;
  }

  return (
    <section aria-label="User management">
      {error && (
        <div className="pb-error" role="alert">
          <span><strong>Error:</strong> {error}</span>
        </div>
      )}
      <div className="pb-list">
        {users.map((user) => {
          const isLastAdmin = user.is_superuser && adminCount <= 1;
          return (
            <div key={user.id} className="pb-feed-row">
              <span className="pb-feed-dot" aria-hidden="true" />
              <div className="pb-feed-name">
                <span className="pb-feed-name-label">{user.email}</span>
                <span className="pb-feed-name-error" style={{ color: 'var(--pb-ink-muted)' }}>
                  {user.is_superuser ? 'Admin' : 'User'}
                </span>
              </div>
              <button
                type="button"
                className="pb-chip"
                onClick={() => toggle(user)}
                disabled={isLastAdmin}
              >
                {user.is_superuser ? 'Revoke admin' : 'Make admin'}
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default AdminUsers;
